import { Injectable } from "@angular/core";
import { Api } from "../../core/classes/api";
import { Observable } from "rxjs";
import {
  GetClientsResponse,
  ClientModel,
  UpdateClientResponse,
  CreateClientResponse,
  DeleteClientResponse,
  GetClientOneResponse
} from "../../core/models/client.model";
import { GetCountriesResponse } from "../../core/models/countries.model";
import { GetTypeDocumentResponse } from '../../core/models/type-document.model';

@Injectable({
  providedIn: 'root'
})
export class ClientService extends Api {
  constructor() {
    super();
  }

  getAll(): Observable<GetClientsResponse> {
    return this.http.get<GetClientsResponse>(`${this.url}/clients`)
  }

  getOne(id: number) {
    return this.http.get<GetClientOneResponse>(`${this.url}/clients/${id}`)
  }

  getDetail(id: number) {
    return this.http.get<GetClientOneResponse>(`${this.url}/clients/${id}/detail`)
  }

  update(id: number, body: FormData) {
    return this.http.post<UpdateClientResponse>(`${this.url}/clients/${id}`, body)
  }
  
  createClient(newClient: FormData) {
    return this.http.post<CreateClientResponse>(`${this.url}/clients`, newClient);
  }

  updateClient(id: ClientModel['id'], formData: FormData) {
    return this.http.post<UpdateClientResponse>(`${this.url}/clients/${id}`, formData);
  }

  deleteClient(id: ClientModel['id']) {
    return this.http.delete<DeleteClientResponse>(`${this.url}/clients/${id}`);
  }

  getCountries(): Observable<GetCountriesResponse> {
    return this.http.get<GetCountriesResponse>(`${this.url}/countries`);
  }

  getTypeDocument(): Observable<GetTypeDocumentResponse> {
    return this.http.get<GetTypeDocumentResponse>(`${this.url}/type-documents`);
  }
}
